// export const BASE_URL = "http://192.168.0.103:9090";

// 根据环境来选择api地址
let baseUrl = window.location.hostname;
let BASE_URL_FOR_API = "";
let BASE_URL_FOR_STOCK = "";
let WS_URL = "";
console.log(baseUrl)
switch (baseUrl) {
    case "localhost":
        // BASE_URL_FOR_API = 'https://prod-api.huoxingy.com/';
        // BASE_URL_FOR_STOCK = "https://prod-api.huoxingy.com/v1/stock/"
        BASE_URL_FOR_API = 'https://staging-api.huoxingy.com/';
        BASE_URL_FOR_STOCK = "https://staging-api.huoxingy.com/v1/stock/"
        WS_URL = "https://staging-ws.huoxingy.com/";
        break;
    case "10.0.0.23":
        BASE_URL_FOR_API = 'https://staging-api.huoxingy.com/';
        BASE_URL_FOR_STOCK = "https://staging-api.huoxingy.com/v1/stock/"
        WS_URL = "https://staging-ws.huoxingy.com/";
        break;
    case "192.168.2.68":
        BASE_URL_FOR_API = 'https://staging-api.huoxingy.com/';
        BASE_URL_FOR_STOCK = "https://staging-api.huoxingy.com/v1/stock/"
        WS_URL = "https://staging-ws.huoxingy.com/";
        break;
    case "staging-admin.huoxingy.com":
        BASE_URL_FOR_API = 'https://staging-api.huoxingy.com/';
        BASE_URL_FOR_STOCK = "https://staging-api.huoxingy.com/v1/stock/"
        WS_URL = "https://staging-ws.huoxingy.com/";
        break;
    case "prod-test-admin.huoxingy.com":
        BASE_URL_FOR_API = 'https://prod-test-api.huoxingy.com/';
        BASE_URL_FOR_STOCK = "https://prod-test-api.huoxingy.com/v1/stock/"
        WS_URL = "https://prod-test-ws.huoxingy.com/";
        break;
    default:
        BASE_URL_FOR_API = 'https://prod-api.huoxingy.com/';
        BASE_URL_FOR_STOCK = "https://prod-api.huoxingy.com/v1/stock/"
        WS_URL = "https://prod-ws.huoxingy.com/";
        break;
}
//
export const BASE_URL = BASE_URL_FOR_STOCK;
export const API_BASE_URL = BASE_URL_FOR_API;
export const WS_API_URL = WS_URL;



// WEBPACK FOOTER //
// ./src/urlConfig/index.js